import '../../scss/entries/app.scss';
import { initAnnouncementBar } from '../modules/announcement-bar';
import { initSiteHeader } from '../modules/site-header';
import { exposeFragmentRuntimeApi, observeDynamicFragments, scanForFeatures } from '../runtime/fragment-runtime';
import { initBootstrapRuntime } from '../shared/bootstrap';
import { onReady } from '../shared/dom';
import { hasMatchMedia, hasMutationObserver, hasResizeObserver } from '../shared/platform';

onReady(() => {
  document.documentElement.classList.add('js');
  document.documentElement.dataset.runtimeMutationObserver = hasMutationObserver() ? 'available' : 'manual';
  document.documentElement.dataset.runtimeResizeObserver = hasResizeObserver() ? 'available' : 'fallback';
  document.documentElement.dataset.runtimeMatchMedia = hasMatchMedia() ? 'available' : 'fallback';
  initBootstrapRuntime();
  initAnnouncementBar();
  initSiteHeader();
  exposeFragmentRuntimeApi();
  scanForFeatures(document);
  observeDynamicFragments();
});
